import { render, staticRenderFns } from "./EvaluateObjectGroupSave.vue?vue&type=template&id=06fc2252&scoped=true&"
import script from "./EvaluateObjectGroupSave.vue?vue&type=script&lang=js&"
export * from "./EvaluateObjectGroupSave.vue?vue&type=script&lang=js&"
import style0 from "./EvaluateObjectGroupSave.vue?vue&type=style&index=0&id=06fc2252&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06fc2252",
  null
  
)

export default component.exports